import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate, IEventUpdate} from "../../services/models/event";
import {toast} from "react-toastify";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";
import {IFolder, IFolderCreate, IFolderUpdate} from "../../types/knowledgeBase.types";

export function useUpdateKBFolder(folderId: string | undefined) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.UPDATE_FOLDER],
        mutationFn: (data: IFolderUpdate) => KnowledgeBaseAPI.updateFolder(data),

        onError() {
            toast.error("Ошибка изменения свойств папки");
        },

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDERS] });
            queryClient.invalidateQueries({ queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_BY_ID, folderId] });
            toast.success("Свойства папки изменены");
        }
    });
}
